<template>
  <div>
    <div v-if="!selecionouFundo">
      <div class="fundo-content" v-for="registro in fundo.dados">
        <RadioButton
          :seleciona="seleciona"
          :imposto="registro"
          :classe="classe"
          :loading="loading"
        />
        <Registro>
          <Cabecalho :titulo="registro.label" :aliquota="registro.aliquota" />
          <div v-if="registro.label && registro.label != 'Não se Aplica'" class="separador" />

          <Ncm
            v-if="registro.aplica != 2 && registro.label != 'Não se Aplica'"
            :ncm="registro.ncm"
          />
          <div
            v-if="(!!registro.ncm && registro.base_legal) || (registro.ncm && registro.descricao)"
            class="separador"
          />

          <Descricao :titulo="'Descrição'" :descricao="registro.descricao" />
          <GrupoNotificacao v-if="registro" :registro="registro" />

          <div v-if="!!registro.descricao && registro.base_legal" class="separador" />

          <BaseLegal :base_legal="registro.base_legal" />
        </Registro>
      </div>
    </div>

    <div :key="getRenderKey" v-else>
      <div class="fundo-content">
        <EditButton
          v-if="fundo.dados.length > 1"
          :edita="edita"
          :classe="classe"
          :loading="loading"
        />
        <Registro :paddingSemCheckBox="fundo.dados.length <= 1">
          <Cabecalho :titulo="fundoSelecionado.label" :aliquota="fundoSelecionado.aliquota" />
          <div
            v-if="fundoSelecionado.label && fundoSelecionado.label != 'Não se Aplica'"
            class="separador"
          />

          <!-- SUPÕE-SE QUE APLICA = 2 É QUANDO NÃO HÁ FUNDO NO SIMPLES -->
          <Ncm
            v-if="fundoSelecionado.aplica != 2 && fundoSelecionado.label != 'Não se Aplica'"
            :ncm="fundoSelecionado.ncm"
          />
          <div
            v-if="
              ((!!fundoSelecionado.ncm && fundoSelecionado.base_legal) ||
                (fundoSelecionado.ncm && fundoSelecionado.descricao)) &&
                fundoSelecionado.aplica != 2
            "
            class="separador"
          />

          <Descricao :titulo="'Descrição'" :descricao="fundoSelecionado.descricao" />
          <GrupoNotificacao v-if="fundoSelecionado" :registro="fundoSelecionado" />

          <div
            v-if="!!fundoSelecionado.descricao && fundoSelecionado.base_legal"
            class="separador"
          />

          <BaseLegal :base_legal="fundoSelecionado.base_legal" />
        </Registro>
      </div>
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

import { mapGetters } from "vuex";

export default {
  name: "RegistrosFundo",

  props: {
    classe: String,
    edita: Function,
    fundo: Object | Array,
    fundoSelecionado: Object,
    loading: Boolean,
    seleciona: Function,
    selecionouFundo: Boolean
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    QuadroPrincipal,
    GrupoNotificacao,
    Ncm,
    RadioButton,
    Registro,
    Notificacao
  },

  data() {
    return {};
  },

  created() {
    if (this.fundo.dados.length == 1) {
      this.seleciona(this.fundo.dados[0]);
    }
  },

  updated() {
    if (this.fundo.dados.length == 1) {
      this.seleciona(this.fundo.dados[0]);
    }
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"])
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.fundo-content {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
</style>
